module.exports = __webpack_public_path__ + "img/course-bg.e84feb0a.png";